import { IUser } from './IUser';

export enum HaggleType {
	PUBLIC = 'PUBLIC',
	SEMI_PRIVATE = 'SEMI_PRIVATE',
	PRIVATE = 'PRIVATE',
}

export interface IHaggleEvent {
	id?: number;
	uuid?: string;
	createdAt?: string;
	updatedAt?: string;
	deletedAt?: string;
	user: IUser;
	productIds: string[];
	startDate: string;
	endDate: string;
	acceptableMargin: number;
	showHaggleBannerOnShopify: string;
	freeShippingThreshold?: number;
	addAutoShopifyPolicy: string;
	customReturnAndExchangePolicy?: string;
	upcomingPreviewDate?: string;
	followUpOfferValidity?: string;
	hostHaggleEventOnShopify?: string;
	isCSVHaggle: boolean;
	haggleType?: HaggleType | null;
	password?: string | null;
	invitedEmails?: string[] | null;
	minOrderValue?: number | null;
	minOrderQuantity?: number | null;
}
